import { Link } from 'react-router-dom';

function LandingHeader() {
  return (
    <header className='text-gray-600 body-font bg-white w-full'>
      <div className='container w-full mx-auto flex flex-col md:flex-row md:items-center md:justify-between p-5'>
        <div className='w-1/2 md:w-1/4 lg:w-36 mx-auto md:mx-0'>
          <Link to='/'>
            <img
              src='https://assets.seinterminal.com/images/logos/SEIN_Terminal_Logo_Color.png'
              alt='Sage Logo'
            />
          </Link>
        </div>
        <nav className='text-sm text-center my-5'>
          <a
            href='https://sein.tech/about'
            target='_blank'
            rel='noreferrer'
            className='mr-5 hover:text-secondaryColor-normal'
          >
            About SEIN Technology Partners
          </a>
          <a
            href='https://sein.tech/products'
            target='_blank'
            rel='noreferrer'
            className='mr-5 hover:text-secondaryColor-normal'
          >
            Products
          </a>
          <a
            href='https://sein.tech/products'
            target='_blank'
            rel='noreferrer'
            className='mr-5 hover:text-secondaryColor-normal'
          >
            FAQ
          </a>
        </nav>
      </div>
    </header>
  );
}

export default LandingHeader;
